import {
  AccessControlProps,
  translatedAccessControlProps,
} from 'modules/access-controls/types';
import useApiMutation from 'shared/hooks/use-api-mutation';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import citiesKeys from '../util/cities-keys';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface CreateCityAccessControlProps
  extends Omit<AccessControlProps, 'id'> {
  createUser?: boolean;
}

export const translatedCreateCityAccessControlProps: TranslatedKeys<CreateCityAccessControlProps> =
  {
    ...translatedAccessControlProps,
    createUser: 'Criar usuário?',
  };

const useCreateCityAccessControl = (cityId: string) => {
  const {create} = useQueryHelpers();

  const onSuccess = (data: AccessControlProps) =>
    create(citiesKeys.accessControls(cityId), data);

  return useApiMutation({
    url: `/access-controls/cities/${cityId}`,
    method: 'POST',
    errorTitle: 'Erro ao cadastrar controle de acesso',
    successTitle: 'Cadastrar controle de acesso',
    successMessage: 'Controle de acesso cadastrado com sucesso',
    redirectUrl: `/settings/cities/${cityId}/access-controls`,
    onSuccess,
  });
};

export default useCreateCityAccessControl;
